import { CSSProperties } from 'react';
import { IObject, IResponse } from "../constants/interface";
import { FormInstance } from 'antd/lib/form';

export interface SuperAutoCompleteProps {
  /** 类名 */
  className?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 输入框提示 */
  placeholder?: string;
  /** 指定当前选中的条目 */
  value?: string;
  /** 指定默认选中的条目 */
  defaultValue?: string;
  /** 选项 (优先级大于接口远程获取) */
  options?: any[];
  /** 额外参数 */
  otherParams?: IObject;
  /** 挂载选项数据的字段 */
  dataKey?: string,
  /** 选项值对应字段 */
  valueKey?: string;
  /** 选项label对应字段 */
  labelKey?: string;
  /** 获取数据时机(默认focus) */
  loadingType?: "init" | 'focus';
  /** 是否每次打开时都重新加载数据(loadingType='focus'是才有效) */
  focusReset?: boolean;
  /** 本地缓存时的存储key(focusReset开启时无效) */
  cacheKey?: string;
  /** 是否禁用 */
  disabled?: boolean;
  /** 下拉菜单的 className 属性 */
  popupClassName?: string;
  /** 支持清除 */
  allowClear?: boolean;
  /** 接口API */
  fetchApi?: (params: any) => Promise<IResponse>;
  /** 请求数据之前参数处理 */
  beforeFetch?: (params: any, record?: any, index?: number) => any;
  /** 获得焦点时的回调 */
  onFocus?: () => void;
  /** 格式化选项 */
  formatOptions?: (options?: any[]) => any[];
  /** 数据加载完成回调 */
  onComplete?: (data?: any) => void;
  /** 搜索回调 */
  onSearch?: (value?: string) => void;
  /** 选中 option，或 input 的 value 变化时，调用此函数 */
  onChange?: (value?: string, option?: any, form?: FormInstance, index?: number, record?: any) => void;
  /** 清除内容时的回调 */
  onClear?: () => void;
};

export enum OPTION_KEY {
  /** 值 */
  VALUE = 'value',
  /** 标题 */
  LABEL = 'label',
}